export default "__VITE_ASSET__4S$Ztrnm__"